/* istanbul ignore file */

import localForage from 'localforage';

export const createStorageInstance = (name: string): LocalForage => {
  return localForage.createInstance({
    name,
  });
};
